import { NavLink } from 'react-router-dom';

import styled from 'styled-components';
import React, {useEffect, useState} from "react";

import * as Server from 'assets/js/Server';
import CustomerHead from '../../components/customer/CustomerHead';

export default function ClientComplaint(){
  const [clientList, setClientList] = useState([]);
  const [currentClient, setCurrentClient] = useState('');

  const [list, setList] = useState([]);
  const [filterType, setFilterType] = useState('ALL'); // ALL | N | Y

  const updateCurrentClient = e => {
    setCurrentClient(e.target.value);
  }

  const getComplaintList = () => {
    Server.sendGet('customer/hq/complaint', {}, getComplaintListCallback).then();
  }

  const getComplaintListCallback = res => {
    setList(res['resultList']);
  }

  const getCleintList = () => {
    Server.sendGet('customer/hq/customer/list', {}, getClientListCallback).then();
  }

  const getClientListCallback = res => {
    setClientList(res['resultList']);
  }

  useEffect(() => {
    getComplaintList();
    getCleintList();
  }, [])

  return (
    <ComplaintWrap>
      <CustomerHead title="Complaint" desc="Voice of Dissatisfaction" />
      <main className="content">
        <div className="card">
          <strong>Customer Requested List</strong>
          <div className='table-content'>
            <table>
              <colgroup>
                <col width='33.33%'/>
                <col width='33.33%'/>
                <col width='33.33%'/>
              </colgroup>
              <tbody>
              <tr>
                <td colSpan={3}>
                  <select
                    value={currentClient}
                    onChange={(e) => updateCurrentClient(e)}
                  >
                    <option value=''>---Select Client---</option>
                    {clientList?.map(item => (
                      <option value={item.custMstSeq}>{item.custName}</option>
                    ))}
                  </select>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div className="request-list">
            <div className="radio-box">
              <div className="radio-item">
                <input
                  type="radio"
                  name="filter"
                  checked={filterType === 'ALL'}
                  onChange={() => setFilterType('ALL')}
                />
                <label htmlFor="all">All</label>
              </div>
              <div className="radio-item">
                <input
                  type="radio"
                  name="filter"
                  checked={filterType === 'N'}
                  onChange={() => setFilterType('N')}
                />
                <label htmlFor="before-process">Before</label>
              </div>
              <div className="radio-item">
                <input
                  type="radio"
                  name="filter"
                  checked={filterType === 'Y'}
                  onChange={() => setFilterType('Y')}
                />
                <label htmlFor="completed-process">Completed</label>
              </div>
            </div>
            <div className="table-wrap">
              <table>
                <colgroup>
                  <col width="25%" />
                  <col width="25%" />
                  <col width="25%" />
                  <col width="25%" />
                </colgroup>
                <thead>
                <tr>
                  <th>Client Name</th>
                  <th>Patrol Area</th>
                  <th>Request date</th>
                  <th>State</th>
                </tr>
                </thead>
                <tbody>
                {list?.filter(item => {
                  // 1. 기존의 답변 여부(replyYn) 필터 조건
                  const matchesReply = filterType === 'ALL' || item.replyYn === filterType;

                  // 2. 추가된 고객사(currentClient) 필터 조건
                  // currentClient가 빈 문자열(전체)이면 true, 값이 있으면 비교 수행
                  const matchesClient = currentClient === '' || String(item.fkCustMstSeq) === currentClient;

                  return matchesReply && matchesClient;
                })?.map((result, idx) => (
                  // ... 리스트 렌더링 ...
                  <>
                    <tr>
                      <td>
                        <NavLink
                          to="/client/state/write"
                          state={{ data: result }}
                        >{result.custName}</NavLink>
                      </td>
                      <td>
                        <NavLink
                          to="/client/state/write"
                          state={{ data: result }}
                        >{result.patrolArea}</NavLink>
                      </td>
                      <td>
                        <
                          NavLink to="/client/state/write"
                          state={{ data: result }}
                        >{result.regDt}</NavLink>
                      </td>
                      <td>
                        <
                          NavLink to="/client/state/write"
                          state={{ data: result }}
                        >{result.replyYn === 'Y' ? 'Completed' : 'Before'}</NavLink>
                      </td>
                    </tr>
                  </>
                ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </ComplaintWrap>
  )
}

const ComplaintWrap = styled.div`
  position: relative;
  background: #F9FAFB;

  .content {
    position:relative;
    padding: 20px;
    height:calc(100vh - 66px);
    
    .card {
      position:relative;
      height:100%;
      background:#fff;
      border-radius:12px;
      padding:20px;
      box-shadow:0 1px 3px rgba(0, 0, 0, 0.1);
      overflow-y:auto;

      strong {
        display:block;
        font-size:18px;
        font-weight:700;
        color:#111827;
      }
      
      .request-list {
        margin-top:25px;
        position:relative;
        height:calc(100% - 155px);
        
        .radio-box {
          display:flex;
          align-items:center;
          gap:0 10px;
          
          .radio-item {
            display:flex;
            align-items:center;
            gap:0 5px;
            
            label {
              font-weight:400;
              font-size:14px;
              color:#111;
            }
          }
        }
      }
      
      .table-content {
        
        table {
          thead th {
            padding: 20px 0;
            font-weight: 400;
            font-size: 14px;
            color: #111111;
            background: #f8f8f8;
            text-align: center;
            border-bottom: 1px solid #eeeeee;
            vertical-align: middle;
          }

          tbody {
            tr {
              td {
                padding: 30px 0;
                font-weight: 400;
                font-size: 14px;
                color: #000000;
                text-align: center;
                vertical-align: middle;
                border-bottom: 1px solid #eeeeee;

                select {
                  padding: 0 16px;
                  height: 40px;
                  line-height: 40px;
                  width: calc(100% - 32px);
                  border-radius: 10px;
                  border-color: #d1d1d1;
                  font-weight: 400;
                  font-size: 14px;
                  color: #111111;
                  background: url('https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/layout/drop_arrow.svg') right 16px top 50% no-repeat;
                  outline: none;
                }

                button {
                  padding: 0 20px;
                  height: 40px;
                  line-height: 40px;
                  border-radius: 10px;
                  font-weight: 400;
                  font-size: 14px;
                  color: #111111;
                  background: #f1f1f1;
                }

                span {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 9999px;
                  width: 30px;
                  height: 20px;
                  line-height: 20px;
                  font-size: 14px;
                  color: #ffffff;


                  &.Y {
                    background: rgb(34, 197, 94);
                  }

                  &.N {
                    background: rgb(239, 68, 68);
                  }

                  &.C {
                    background: rgb(234, 179, 8);
                  }
                }
              }
            }
          }
        }
      }
      
      .table-wrap {
        margin-top:30px;
        position:relative;
        max-height:calc(100% - 50px);
        overflow-y:auto;
        width:100%;
        
        table {
          width:100%;
          
          thead {
            position:sticky;
            top:0;
            left:0;
          }
          
          th {
            padding:10px 20px;
            font-weight:500;
            font-size:14px;
            color:#fff;
            background:#0072B9;
            vertical-align: middle;
          }
          
          th + th {
            border-left:1px solid #fff;
          }
          
          td {
            padding:10px 20px;
            font-weight:500;
            font-size:14px;
            color:#111;
            border-bottom:1px solid #d4d4d4;
            text-align:center;
          }
          
          td + td {
            border-left:1px solid #d4d4d4;
          }
        }
      }
    }
    
    .float-btn {
      z-index:999;
      position:fixed;
      bottom:80px;
      right:30px;
      width:45px;
      height:45px;
      background:#0072B9;
      border-radius:50%;
      display:flex;
      justify-content: center;
      align-items: center;
      font-size:16px;
      font-weight:600;
      color:#fff;
    }
  }
`
